
import { genMessage } from '../helper';
// 修改文件
const modules = import.meta.glob('./cn/*.ts', { eager: true });

export default {
	message: {
		...genMessage(modules, 'cn'),
	},
	dateLocaleName: 'Cn',
};
